import { UIComponent } from "@aptus/frontend-core";
import { AutoCompleteSelect } from "components/form/autoCompleteSelect/autoCompleteSelect";
import { RegionSelectProps, useRegionSelect } from "./useRegionSelect";

export const RegionSelect: UIComponent<RegionSelectProps> = (props) => (
	<AutoCompleteSelect {...useRegionSelect(props)} />
);
